<template>
    <div>
        <vc-left-menu/>
        <div :class="{
            'layout-content': true,
            'contents-scroll__wrapper': true,
            'is-active': !getMenuToggle }"
        >
            <PerfectScrollbar style="width: 100%; height: 100%">
                <ContentHeader
                    :file-register-name="$t('words.wait_media_content_register')"
                    :title="$t('words.wait_media_content_list')"
                    :totalProgress="totalProgress"
                    @showRegisterModal="showRegisterModal"
                />

                <ContentActionBar
                    :mediaContents="mediaContents"
                    @doRefresh="doRefresh"
                    @loadMediaContents="loadMediaContents"
                />

                <ContentBody
                    :mediaContents="mediaContents"
                    :order="order"
                    @doRemoveMediaContent="doRemoveMediaContent"
                    @doSearch="doSearch"
                    @setOrder="setOrder"
                />
            </PerfectScrollbar>
        </div>

        <WaitMediaContentsUploadModal/>
        <PreviewModal/>
    </div>
</template>

<script>
import axios from 'axios';
import debounce from 'lodash/debounce';
import GlobalConfigMixin from '@/components/mixin/GlobalConfigMixin';
import ContentHeader from '@/components/cms/common/Content/ContentHeader';
import ContentActionBar from '@/components/cms/common/Content/ContentActionBar';
import ContentBody from '@/components/cms/common/Content/ContentBody';
import WaitMediaContentsUploadModal from '@/components/cms/program/Modal/WaitMediaContentsUploadModal';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import PreviewModal from '@/components/cms/program/Modal/PreviewModal';

const storeModuleName = 'wait_media_contents';

export default {
    components: {
        ContentHeader,
        ContentActionBar,
        ContentBody,
        WaitMediaContentsUploadModal,
        PreviewModal,
    },
    mixins: [
        GlobalConfigMixin,
    ],
    data() {
        return {
            registerModalOpen: false,
            toasted: false,
        };
    },

    computed: {
        ...mapGetters(storeModuleName, [
            'progressIdx',
            'reloadIdx',
            'order',
            'mediaContents',
            'mediaContentsApi',
        ]),
        ...mapGetters('wait_media_contents_upload', ['totalProgress']),
        haveSubmitRight() {
            return this.haveOwnerRight;
        },
    },

    watch: {
        loadedServiceAccount(newValue) {
            this.initialize();
        },
        reloadIdx: debounce(function (newValue, oldValue) {
            if (newValue !== 1) {
                this.loadMediaContents(this.mediaContentsApi);
            }
        }, 20000),
        progressIdx: debounce(function (newValue, oldValue) {
            if (newValue !== 1) {
                this.getTranscodingProgress();
            }
        }, 5000),
    },

    mounted() {
        $('#registerModal').on('hide.bs.modal', () => {
            this.registerModalOpen = false;
        });
        this.clearMediaContents();
        $('#registerModal').on('hidden.bs.modal', () => {
            this.doSearch();
        });

        $('#previewModal').on('hidden.bs.modal', () => {
            this.clearPreview();
        });
        if (this.loadedServiceAccount) {
            this.initialize();
        }
    },
    beforeDestroy() {
        this.clearReloadAndProgressIdx(); // store mutation
        if (!_.isNull(this.toasted) && this.toasted !== false) {
            this.toasted.goAway(0);
        }

        $('#registerModal').hide();
        $('.modal-backdrop').remove();
    },
    methods: {
        ...mapMutations({
            setOrder: `${storeModuleName}/setOrder`,
            clearReloadAndProgressIdx: `${storeModuleName}/clearReloadAndProgressIdx`,
            finishUploadInit: `${storeModuleName}/finishUploadInit`,
            clearMediaContents: `${storeModuleName}/clearMediaContents`,
            clearPreview: 'preview/clearPreview',
        }),
        ...mapActions({
            loadMediaContents: `${storeModuleName}/loadMediaContents`,
            getTranscodingProgress: `${storeModuleName}/getTranscodingProgress`,
            doSearch: `${storeModuleName}/doSearch`,
            initializeSearch: `${storeModuleName}/initializeSearch`,
        }),
        initRegisterModal() {
            this.registerModalOpen = false;
        },
        showRegisterModal() {
            this.registerModalOpen = true;
            this.clearReloadAndProgressIdx();
            $('#registerModal').modal({});
        },
        // initialize search
        initialize() {
            this.global_reload_path = 'cms-channels-list';
            this.initializeSearch();
        },
        doRefresh() {
            this.initialize();
        },
        doRemoveMediaContent(mediaContent) {
            if (!this.haveSubmitRight) {
                return;
            }
            if (mediaContent.programs_ready > 0) {
                this.$toasted.error(this.$t('paragraphs.message.error.remove_program_file_ready_schedule'));
                return;
            }
            if (confirm(this.$t('paragraphs.message.confirm.remove_program_file', {
                title: mediaContent.title,
                contents_type: this.$t('words.wait_media_content'),
            }))) {
                axios.delete(`/cms/${this.selectedServiceAccount.key}/programs/media_contents`, {
                    data: { selecteds: [{ id: mediaContent.id, upload_file_key: mediaContent.upload_file_key }] },
                }).then(() => {
                    this.$toasted.success(this.$t('paragraphs.message.success.remove_program_file'));
                    // this.loadMediaContents(this.mediaContentsApi);
                    this.doSearch();
                }).catch((error) => {
                    this.$toasted.error(this.$t('paragraphs.message.error.remove_program_file'));
                    logger.error(error.response.data.errors);
                });
            }
        },
        doUploadFile() {
            const formData = new FormData();
            const file = this.$refs.wait_media_content.files[0];
            if (typeof file === 'undefined') {
                this.$toasted.error(this.$t('paragraphs.please_select_file'));
                return;
            }

            this.file.isUploading = true;
            this.file.meta.errors = {};
            this.axiosRequest = axios.CancelToken.source();

            formData.append('upload_file', file);
            axios.post(`${this.uploadFileToWaitCategoryApi}`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
                cancelToken: this.axiosRequest.token,
                onUploadProgress: (event) => {
                    const totalLength = event.lengthComputable
                        ? event.total
                        : event.target.getResponseHeader('content-length')
                        || event.target.getResponseHeader('x-decompressed-content-length');
                    if (totalLength != null) {
                        this.file.progressValueNow = _.round((event.loaded * 100) / event.total);
                    }
                },
            }).then((response) => {
                this.finishUpload();

                this.toasted = this.$toasted.show(this.$t('paragraphs.program_file_uploaded', {
                    file_name: file.name,
                }), {
                    theme: 'toasted-primary',
                    position: 'bottom-center',
                    duration: null,
                    iconPack: 'fontawesome',
                    action: {
                        icon: 'times',
                        onClick: (e, toastObject) => {
                            toastObject.goAway(0);
                        },
                    },
                });
            }).catch((error) => {
                // 파일 업로드 중 중단한 케이스이므로.. 에러 메시지를 보여주지 않는다.
                // this.$toasted.error(this.$t('paragraphs.message.error.upload'));
                this.file.meta.errors = error.response.data.errors;
                this.file.isUploading = false;
                if (typeof error.response.data.message === 'string' && error.response.data.message !== '') {
                    this.$toasted.error(error.response.data.message, { position: 'top-center', duration: 3000 });
                }
            });
        },
        // step last: finish
        finishUpload() {
            this.finishUploadInit();

            $('#registerModal').modal('hide');

            this.doSearch();

            this.initRegisterModal();
        },
    },

};
</script>

<style>
.sortable {
    cursor: pointer;
}
</style>
